import React, { Fragment } from 'react';
import { User, UserAttribute } from '../model/Model';
import { AuthService } from '../services/AuthServices';
import { Link } from 'react-router-dom';

interface ProfileState {
  userAttributes: UserAttribute[];
}

interface ProfileProps {
  user: User | undefined;
  authService: AuthService;
}

export class Profile extends React.Component<ProfileProps, ProfileState> {
  state: ProfileState = {
    userAttributes: [],
  };

  async componentDidMount() {
    if (this.props.user) {
      const userAtrs = await this.props.authService.getUserAttributes(
        this.props.user,
      );
      this.setState({
        userAttributes: userAtrs,
      });
    }
  }

  private renderUserAttrributes() {
    const rows = [];

    for (const userAttribute of this.state.userAttributes) {
      rows.push(
        <tr key={userAttribute.Name}>
          <td>{userAttribute.Name}</td>
          <td>{userAttribute.Value}</td>
        </tr>,
      );
    }
    return (
      <table>
        <tbody>{rows}</tbody>
      </table>
    );
  }

  render() {
    let profileSpace;
    if (this.props.user) {
      profileSpace = (
        <Fragment>
          <h3>Hello {this.props.user.userName}</h3>
          Here are your atteibutes:
          {this.renderUserAttrributes()}
        </Fragment>
      );
    } else {
      profileSpace = (
        <Fragment>
          <h2>Please Log in</h2>
          <Link to="../login">Log in</Link>
        </Fragment>
      );
    }
    return (
      <Fragment>
        <h1>Welcome to the Profile page</h1>
        {profileSpace}
      </Fragment>
    );
  }
}
